/**
 * Google Analytics (GA4) integration.
 * Set REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX) to enable.
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    // Keep this loose to match the official gtag.js signature and avoid TS friction.
    gtag?: (...args: any[]) => void;
    dataLayer?: unknown[];
  }
}

function loadGtagScript(): void {
  if (!MEASUREMENT_ID || typeof document === 'undefined') return;
  if (document.querySelector('script[src*="googletagmanager.com"]')) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer?.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });
}

export function initAnalytics(): void {
  if (MEASUREMENT_ID) loadGtagScript();
}

export function trackPageView(path: string, title?: string): void {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('config', MEASUREMENT_ID, {
    page_path: path,
    page_title: title ?? document.title,
  });
}

export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>
): void {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}
